export const themesStylesBase = {
  brandBlue: "rgb(57, 117, 246)",
  brandRed: "rgb(179, 32, 35)",
  brandWhite: "rgb(255, 255, 255)",
  ghostWhite: "rgb(248, 248, 248)",
  brandYellow: "rgb(244, 167, 0)",
  brandGrey: "rgb(243,246,249)",
  primary: "rgb(57, 117, 246)",
  fontMono: "'Courier', monospace",
  fontSans: "'Source Sans Pro', 'Arial', sans-serif",
  fontSerif: "'Bree Serif', 'Times', serif",
  fontRobotoRegular: "Roboto Regular",
  fontRobotoRegMedium: "Roboto Medium Regular",
  fontRobotoBold: "Roboto Bold",
  baseFontColor: "#4f4f4fff",
  baseFontFamily: "'Source Sans Pro', 'Arial', sans-serif",
  baseFontSize: "16px",
  baseBorderColor: "rgb(217, 228, 232)",
  altFontColor: "rgb(255, 255, 255)",
  gridBackColor: "rgb(179, 32, 35,0.1)",
  baseColor: "rgb(242, 242, 242)",
  fontBook: 300,
  fontNormal: 400,
  fontMedium: 500,
  fontSemibold: 600,
  fontBold: 700,
  baseLineHeight: 1.5,
  headings: "6 5 4 3 2 1",
  baseBorder: "1px solid rgb(84, 106, 120)",
  baseRadius: "0.25rem",
  baseBoxShadow: "rgba(42, 53, 60, 0.2) 0 0 5px",
  borderBottom: "#E6E6E6",
  fontGrey: "#999999",
  darkGrey: "#4D4D4D",
  fontBlue: "#288FD4",
  lightGrey: "#45474b",
  lightDark: "#333333",
  greyBorder: "#d3d3d3",
  darkYellow: "#ffc20e",
  fontRed: "#FF0000",
  fontDarkBlue: "#0000FF",
  font_family:
    "'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif",
  font_family_medium: "HelveticaNeue-Medium",
  font_family_bold: "'HelveticaNeue-Bold','texgyreheros-bold',arial,sans-serif",
  lightGreen: "#51A865",
  boldRed: "#ec171e",
  grey: "#dbdbdb",
  borderGrey: "#cccccc",
  black: "#000000",
  buttonBlue: "#5482b9",
  buttonDarkBlue: "#345f91",
  blueHover: "#2d5a91",
  fontOrange: "#FE8F28",
  greyLight: "#ebebeb",
  greyDarkBorder: "#d0d2d3",
  greyBorderLine: "#d9d9d9",
  backgroundGrey: "#e8e8e8",
  borderLightGrey: "#dfdfdf",
  textGrey: "#666666",
  disabledBlue: "#3a5c85",
  readGrey: "#5F5F5F",
  warningRed: "#d32337",
  backgroundDarkGrey: "#F8F8F8",
  emptyViewColor: "#7F7F7F",
  fillColorYellow: "#FDC010",
  fillColorGreen: "#7ACC5A",
  fillColorRed: "#E25153",
  lightBlue: "#5582BA",
  transparent: "transparent",
  primaryHoverBlue: "#2F608C",
  primaryDisabledBlue: "#CCDAEB",
  primaryDisabledBorder: "#C1CFDD",
  secondaryHoverBlue: "#99B4D6",
  dropdownHover: "rgba(85,130,186,0.1)",
  dropdownBoxShadow: "0 2px 4px 1px rgba(0,0,0,0.2)",
  dropdownItem: "rgba(0, 0, 0, 0.7)",
  disabledLabel: "#B2B2B2",
  greyBackground: "#BBBBBB",
  darkGreyBorder: "#949494",
  superDarkGrey: "#191919",
  mediumDarkGrey: "#8A8A8A",
  lightGreyBackground: "#F7F7F7",
  grey5E5E5E: "#5E5E5E",
  grey1A1A1A: "#1A1A1A",
  greyE2E2E2: "#E2E2E2",
  darkGrey878787: "#878787",
  lightGreyA0A0A0: "#A0A0A0",
  lightGreyA4A4A4: "#A4A4A4",
  hexGray575757: "#575757",
  redE03D3D: "#E03D3D",
  orangeF68244: "#F68244",
  pinkFFF8F8: "#FFF8F8",
  lightRed: "#F77777",
  darkBlue: "#3D4FA6",
  dodgerBlue: "#3875FB",
  severityRed: "#DF3C3C",
  orangeFFF8F4: "#FFF8F4",
  grayF2F2F2: "#F2F2F2",
  lightGrayBlue: "#f3f6f9",
  borderGraySolid: "1px solid #e6e6e6",
  borderGreenSolid: "1px solid #59AA00",
  borderYellowSolid: "1px solid #FFC20E",
  borderRedSolid: "1px solid #E25153",
  green59AA00: "#59AA00",
  yellowFFC20E: "#FFC20E",
  redE25153: "#E25153",
  borderGraySolidImportant: "2px solid #e6e6e6 !important",
  fontWeightBold: "bold",
  textGreyImportant: "#666666 !important",
  textDarkGrayImportant: "#b3b3b3 !important",
  darkGreyImportant: "#4D4D4D !important",
  grayRGBA: "rgba(0, 0, 0, 0.7)",
  yellowffc539: "#ffc539",
  yellowF5A623: "#F5A623",
  greenRGB: "rgba(122,204,90,0.1)",
  yellowRGB: "rgba(255,197,57,0.1)",
  yellowRGBA: "rgba(245,166,35,0.1)",
  redRGB: "rgba(226,81,83,0.1)",
  greyRGB: "rgba(204,204,204,0.1)",
  error: "#d30505",
  screensHeader: "#FFFFFF",
  successGreen: "#069f39",
  greyHover: "#fafafa",
  blue5C84AD: "#5C84AD",
  borderGraySolid: "1px solid #ddd",
  borderBlueSolid: "2px solid #008cba80"
};

export default themesStylesBase;
